import React from 'react';
import { IconButton, MenuItem, Menu, Box } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

export interface MenuActionType<T> {
  actionName: ((item: T) => string) | string;
  onClick: (item: T) => void;
  permission?: string;
  isDisabled?: (item: T) => boolean;
}

export interface ActionMenuProps<T> {
  actions: MenuActionType<T>[];
  item: T ;
}

export interface IdObj {
  id?: string | number | undefined | null;
}

export const ActionMenu= <T extends IdObj>(
  props: React.PropsWithChildren<ActionMenuProps<T>>
):JSX.Element => {
  const { actions, item } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openClientMenu = Boolean(anchorEl);

  const handleOpenClientMenu = (event: React.MouseEvent<HTMLElement>): void =>
    setAnchorEl(event.currentTarget);

  const handleCloseClientMenu = (): void => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton onClick={handleOpenClientMenu} size='small'>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        open={openClientMenu}
        onClose={handleCloseClientMenu}
      >
        {actions.map((action, i) => {
          const disabled = action.isDisabled ? action.isDisabled(item) : false;
          return (
            <MenuItem
              key={i}
              onClick={() => {
                action.onClick(item);
                handleCloseClientMenu();
              }}
              disabled={disabled}
            >
              {typeof action.actionName === 'function'
                ? action.actionName(item)
                : action.actionName}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};